import { styled } from "@mui/material/styles";

import { ProgressSteps } from "./ProgressSteps";

export const ProgressActiveSteps = styled(ProgressSteps)(
  ({ theme, color }) => ({
    backgroundColor: color || theme.palette.warning.dark,
  })
);
